<div class="d-flex justify-content-end">
  <div class="mr-2">
    <!-- <app-services-clock></app-services-clock> -->
  </div>
  <div class="content__profile" ngbDropdown>
    <a [routerLink]="[]" ngbDropdownToggle>
      <span class="content__profile-username secondary">{{ dataUser ? dataUser.name : '' }}</span>
      <img src="https://upload.wikimedia.org/wikipedia/commons/9/95/Alex_Von_Furstenberg_-profile.jpg" alt=""
        class="content__profile-image rounded-circle">
    </a>
    <div ngbDropdownMenu>
      <button ngbDropdownItem (click)="editProfile($event, contentEditProfile)">Editar perfil</button>
      <button style="margin-left: 0;" ngbDropdownItem [routerLink]="['/login']" (click)="authService.logout()">
        Cerrar sesión
      </button>
    </div>

    <!-- <a class="btn btn-primary content__statistics-button" style="color: white;"><i class="fas fa-chart-bar"></i></a> -->
  </div>
</div>

<ng-template #contentEditProfile let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Editar perfil</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label for="">Foto</label>
      <input type="file" class="form-control">
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="saveUser()">Enviar</button>
  </div>
</ng-template>